import { SELECTED_COMPANY_ID } from '../constants';

export const getCompanyIdFromLocalStorage: () => number | undefined = () => {
  const companyId = window.localStorage.getItem(SELECTED_COMPANY_ID);
  return companyId ? Number(companyId) : undefined;
};
